import { Folder, ChevronRight } from 'lucide-react';
import LinkedBadge from './LinkedBadge';

interface FolderRowProps {
    name: string;
    subtitle?: string;
    onClick: () => void;
    linked?: boolean;
    // Shown when the folder isn't itself linked.
    linkedCount?: number;
}

export default function FolderRow({ name, subtitle, onClick, linked, linkedCount }: FolderRowProps) {
    return (
        <button
            onClick={onClick}
            className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-offwhite rounded-lg transition-colors text-left group"
        >
            <Folder className="w-5 h-5 text-brand shrink-0" />
            <div className="flex-1 min-w-0">
                <span className="block font-medium text-graphite text-sm truncate">{name}</span>
                {subtitle && (
                    <span className="block text-xs text-coolslate truncate">{subtitle}</span>
                )}
            </div>
            {linked ? (
                <LinkedBadge />
            ) : linkedCount && linkedCount > 0 ? (
                <LinkedBadge count={linkedCount} />
            ) : null}
            <ChevronRight className="w-4 h-4 text-coolslate/50 group-hover:text-coolslate transition-colors shrink-0" />
        </button>
    );
}
